/*

  s t a t i c s
  Statics

  :description:
  A file to hold onto our statics, enums, etc.

*/

export const PLATFORM_UNSET = null
export const PLATFORM_IOS = "ios"
export const PLATFORM_ANDROID = "android"
export const PLATFORM_QR = "qr"
export const KNOWN_PLATFORMS = [PLATFORM_UNSET, PLATFORM_IOS, PLATFORM_ANDROID]

export const MESSAGE_GROUP_DEFAULT = `eky-ar-launch`
export const MESSAGE_GROUP_ANDROID = `${MESSAGE_GROUP_DEFAULT}-android`
export const MESSAGE_GROUP_IOS = `${MESSAGE_GROUP_DEFAULT}-ios`
export const MESSAGE_GROUP_QR = `${MESSAGE_GROUP_DEFAULT}-qr`

export const SERVICE_AR_MODELS = "ar-models"
export const SERVICE_AR_ASSISTANT = "ar-assistant"
export const KNOWN_SERVICES = [SERVICE_AR_ASSISTANT, SERVICE_AR_MODELS]

export const QR_TYPE_DELIVERY = "delivery"
export const QR_TYPE_SCAN = "scan"

//
//  :urls:
export const MODEL_CDN_BASE_URLS = {
  dev: "https://eyekandy-model-staging.s3.eu-west-2.amazonaws.com",
  prod: "https://d15mv1adrb1s6e.cloudfront.net/product_bundles"
}

export const KNOWN_ENVIRONMENTS = Array.from(Object.keys(MODEL_CDN_BASE_URLS))

//
//  :dom:
export const NODE_ID = "eyekandy-div"
